import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";
import { forms } from "../../../forms";

const update = async (data: FormData) => {
  const response: TServerResponse = await request({
    url: apiUrls.blogBanner.UPDATE_BLOG_BANNER,
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const useUpdateBlogBannerMutation = () => {
  return useMutation({ mutationFn: update });
};
